import React, { FC } from 'react';

const Divider: FC = () => (
  <hr className="divider demo-divider__hr-horizontal" />
);

export default Divider;
